interface RoundButtonProps
	extends React.DetailedHTMLProps<
		React.ButtonHTMLAttributes<HTMLButtonElement>,
		HTMLButtonElement
	> {}
function classNames(...classes: (string | boolean)[]) {
	return classes.filter(Boolean).join(" ");
}
export default function RoundButton(Props: RoundButtonProps) {
	const { disabled, children, className } = Props;
	return (
		<button
			{...Props}
			type="button"
			className={classNames(
				!disabled
					? className || ""
					: "bg-gray-400 text-gray-700 hover:bg-gray-400",
				"rounded-full p-2 shadow-sm",
			)}
		>
			{children}
		</button>
	);
}
